var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"twinkle-twinkle"},[_c('speaker-notes',{attrs:{"notes":_vm.notes}}),_c('h2',[_vm._v("... into this?")]),_c('music-display',{attrs:{"abc":_vm.twinkle,"has-audio":true,"large":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }